import createSvgIcon from '@icons/utils/create-svg-icon';
import ChevronRightSvg from './svg/chevron-right.svg';

const ChevronRightIcon = createSvgIcon(ChevronRightSvg);

export default ChevronRightIcon;
